{
  "id": 21,
  "location": "paris",
  "difficulty": "normal",
  "moves": 21,
  "kinds": 6,
  "goals": [
    { "type": "stain" },
    { "type": "mud" }
  ],
  "stars": [2760, 4360],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . X . . X . .",
    ". . . . . . . .",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.758, "movesLeft": 8.4, "closeLosses": 0.233, "target": 0.74 }
}
